<template>
  <div class="transfer-page">
    <Hero :title="hero?.title" :description="hero?.description">
      <template #image>
        <ElementsImage v-if="hero?.image" v-bind="hero.image" loading="eager" />
      </template>
    </Hero>
    <ElementsContainer>
      <div class="transfer">
        <ElementsSection
          :title="$t('transfer.index.typeTitle')"
          :description="$t('transfer.index.typeDescription')"
        >
          <div class="flex flex-wrap -mx-4 gap-y-10">
            <div v-for="(method, index) in methods" :key="index" class="w-full lg:w-1/2 px-4">
              <div class="transfer-card">
                <div class="transfer-card__image">
                  <ElementsImage v-if="method.image" v-bind="method.image" loading="lazy" />
                </div>
                <div class="transfer-card__content">
                  <div class="transfer-card__content-title">{{ method.title }}</div>
                  <div class="transfer-card__content-description">{{ method.description }}</div>
                  <div class="transfer-card__content-actions">
                    <ElementsButton :href="`/transfer/${method.slug}`" variant="outline" color="secondary">{{ $t('transfer.index.selectButton') }}</ElementsButton>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ElementsSection>
      </div>
    </ElementsContainer>
  </div>
</template>

<script setup lang="ts">
  import fetchApi from "~/utils/fetchApi"

  const { data: responseData } = await useAsyncData("transfer-page", () =>
    fetchApi<any>("transfer-page", {
      wrappedByKey: "data",
      populate: {
        hero: { populate: "*" },
        methods: { populate: "*" }
      }
    })
  )

  const hero = computed(() => responseData.value?.hero || {})
  const methods = computed(() => responseData.value?.methods || [])

  const { t } = useI18n()

  useSeoMeta({
    title: () => hero.value?.title || t("menu.transfer"),
    description: () => hero.value?.description || ""
  })
</script>

<style lang="scss" scoped>
  .transfer {
    width: 100%;
    max-width: 1000px;
    margin: 0 auto;

    &-card {
      border: 1px solid #e5e5e5;
      background: #fff;
      display: flex;
      overflow: hidden;
      flex-direction: column;
      height: 100%;

      &__image {
        width: 100%;
        height: auto;

        :deep(img) {
          width: 100%;
          height: auto;
          object-fit: cover;
        }
      }
      &__content {
        display: flex;
        flex-direction: column;
        padding: 24px;
        height: 100%;

        &-title {
          @apply font-display;
          color: #000;
          font-size: 24px;
          font-weight: 500;
          line-height: 34px;
          letter-spacing: 1.5px;
          text-transform: uppercase;
        }
        &-description {
          color: rgba(0, 0, 0, 0.6);
          font-size: 16px;
          font-weight: 500;
          line-height: 22px;
          letter-spacing: 0.16px;
          margin-top: 6px;
          margin-bottom: 24px;
        }
        &-actions {
          margin-top: auto;
        }
      }
    }

    @include media("lg") {
      &-card {
        &__content {
          padding: 16px;

          &-title {
            font-size: 16px;
            line-height: 24px;
          }
          &-description {
            font-size: 14px;
            line-height: 20px;
            margin-top: 4px;
            margin-bottom: 16px;
          }
        }
      }
    }
  }
</style>
